export const themeOptionFactory = (theme) => ({
  components: {
    AppSidebar: {
      styleOverrides: {
        modalContainer: {
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "white",
          borderRadius: "20px",
          padding: "12px",
          width: "326px",
          height: "222px",
        },
        modalContent: {
          position: "relative",
          textAlign: "center",
          "& .MuiTypography-root": {
            fontWeight: 400,
          },
        },
        modalCloseButton: {
          position: "absolute",
          top: -20,
          right: -20,
          width: "32px",
          height: "32px",
          backgroundColor: "#ECECED",
          "& .MuiSvgIcon-root": {
            width: "10px",
            height: "10px",
            color: "#494656",
          },
          ":hover": {
            backgroundColor: "#ECECED",
          },
        },
        descriptionContainer: {
          marginTop: theme.spacing(1),
          display: "flex",
          justifyContent: "center",
        },
        descriptionText: {
          width: "170px",
          fontSize: "0.875rem",
          color: "#8C8A94",
          textAlign: "center",
        },
        contactContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: theme.spacing(2.5),
        },
        callButton: {
          border: "none",
          fontSize: "1rem",
          color: theme.palette.text.primary,
          "& .MuiButton-startIcon": {
            marginRight: theme.spacing(0.5),
            "& svg": {
              fontSize: "1.5rem",
              fill: "currentColor",
            },
          },
          ":hover": {
            border: "none",
          },
        },
      },
    },
  },
})
